import ChartManager from './chartManager'

export default class StrategyChartManager extends ChartManager {}
